import React from 'react';
import {
  CardWrapper,
  CheckIcon,
  RadioCustomButton,
  TemplateSection,
} from '../B2G1RadioOptionNewVersion/styled';
import OfferSectionNew from '../B2G1RadioOptionNewVersion/OfferSectionNew';

function DaiperVarientLive(props) {
  const { DiaperOfferData, onChangeHandler, option, onClickHandler } = props;
  return (
    <>
      {DiaperOfferData.map((data, index) => {
        return (
          <React.Fragment key={`radio_${index}`}>
            <TemplateSection key={`offer${index}`}>
              <label htmlFor={data?.id} className="radioLabel">
                <input
                  type="radio"
                  name="radio-card"
                  id={data.id}
                  checked={option === data?.id ? true : false}
                  onChange={() => onChangeHandler(data)}
                  onClick={() => onClickHandler(data)}
                />
                <CardWrapper>
                  <RadioCustomButton>
                    <CheckIcon></CheckIcon>
                  </RadioCustomButton>
                  <OfferSectionNew
                    data={data}
                    index={index}
                    length={DiaperOfferData.length}
                  />
                </CardWrapper>
              </label>
            </TemplateSection>
          </React.Fragment>
        );
      })}
    </>
  );
}

export default DaiperVarientLive;
